// extracted by mini-css-extract-plugin
module.exports = {"s1pxsbbh":"s1pxsbbh"};